import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { func, string, object } from 'prop-types';
import Card from '../../../../components/LazyWidgets/Card';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import ReportError from '../ReportError';
import s from './RevisionPlanNotStarted.module.css';
import { RevisionPlansNotStartedTable } from './components';
import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';
import { fetchRevisionPlansNotStartedReport as fetchRevisionPlansNotStartedReportAction } from '../../../actions/reports';

class RevisionPlanNotStarted extends Component {
  static propTypes = {
    onTabChange: func,
    courseId: string,
    fetchRevisionPlansNotStartedReport: func,
    revisionPlansNotStarted: object,
    reportTitle: string,
    courseName: string,
  };

  constructor(props) {
    super(props);

    this.tableStyle = [
      {
        row: 'zeroStyle',
        cells: [
          { accessor: 'studentName', alignment: 'left' },
          { accessor: 'assignment', alignment: 'right' },
        ],
      },
    ];
  }

  componentDidMount() {
    const { courseId, courseName } = this.props;
    this.props.fetchRevisionPlansNotStartedReport(courseId, courseName);
  }

  renderRevisionsPlans() {
    const { revisionPlansNotStarted: { data }, courseId } = this.props;
    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: this.props.reportTitle }];
    return (
      <div>
        <div className={s.title}>
          Revision Plans Not Started
        </div>
        <ReportBreadcrumbs
          items={breadcrumbItems}
          onTabChange={this.props.onTabChange}
        />
        <Card className={s.revisionPlansCard}>
          <RevisionPlansNotStartedTable
            data={data}
            courseId={courseId}
            tableStyle={this.tableStyle}
            onTabChange={this.props.onTabChange}
          />
        </Card>
      </div>
    );
  }
  render() {
    const { revisionPlansNotStarted: { loading, error } } = this.props;
    if (loading) return <Spinner className={s.spinner} />;
    if (error) return <ReportError />;
    return (
      <div className={s.revisionPlansContainer}>
        {this.renderRevisionsPlans()}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRevisionPlansNotStartedReport: bindActionCreators(fetchRevisionPlansNotStartedReportAction, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    revisionPlansNotStarted: state.reports.skills.revisionPlansNotStarted,
    courseName: state.reports.courseAbstract.shortName,
    reportTitle: state.reports.skills.revisionPlansNotStarted.reportTitle,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RevisionPlanNotStarted);
